module.exports = __webpack_public_path__ + "static/img/logo-reverse.1915a336.png";